import { render, staticRenderFns } from "./QRenewedControl.vue?vue&type=template&id=6c5359f5&scoped=true&"
import script from "./QRenewedControl.vue?vue&type=script&lang=js&"
export * from "./QRenewedControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5359f5",
  null
  
)

export default component.exports